export const CS: Record<string, string> = {
  "Recommended for you": "Doporučeno pro vás",
  "Resource added to favorite": "Zdroj přidán do oblíbených",
  "Failed to add resource to favorite": "Nepodařilo se přidat zdroj do oblíbených",
  "Resource removed from favorite": "Zdroj odebrán z oblíbených",
  "Failed to remove resource from favorite": "Nepodařilo se odebrat zdroj z oblíbených",
  "Calendar": "Kalendář",
  "View Detail": "Zobrazit detail",
  "Add to favorites": "Přidat do oblíbených",
  "Remove from favorites": "Odebrat z oblíbených",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Popis: VIP zasedací místnost s krásným výhledem a pohodlnými židlemi.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Ve zvoleném čase nejsou na vašem místě nebo v oblíbených k dispozici žádné zdroje.",
  "You have these options:": "Máte tyto možnosti:",
  "Change the meeting time.": "Změnit čas schůzky.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Použijte tlačítko <1>Najít dostupný čas</1> k výběru nového času.",
  "Open the search to find other resources.": "Otevřete vyhledávání a najděte další zdroje.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Typ zdroje <1>'{{resourceType}}'</1> neexistuje na vašem výchozím místě",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Typ zdroje <1>'{{resourceType}}'</1> lze najít na jiném místě.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Klikněte zde</1> pro přidání typu zdroje do vašich výchozích nastavení umístění.",
  
  // ResourceCard
  "New Order": "Nová objednávka",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Při rezervaci Pooled Resource lze rezervovat pouze tento typ zdroje a pouze jeden.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Nemůžete vybrat jakýkoli zdroj a jeho virtuální zdroj najednou.",
  // Settings
  "Note:": "Poznámka:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Asistent organizátora může přijímat stejné e-maily z Resource Central jako organizátor a může zpracovávat objednávky jménem organizátora.",
  "Setting updated successfully": "Nastavení úspěšně aktualizováno",
  "Setting updated failed": "Aktualizace nastavení se nezdařila",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 místo",
  "Opening hours:": "Otevírací doba:",
  "Buffer time {{minutes}} mins between reservations": "Vyrovnávací čas {{minutes}} min mezi rezervacemi",
  "Initial payment {{value}} pr.minute": "Počáteční platba {{value}} za minutu",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Celkem {{total}} účastníků",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} z {{total}} interních se může zúčastnit.",
  "{{external}} external is unknown.": "{{external}} externích je neznámých.",
  "Find available time": "Najít dostupný čas",
  "Attendees": "Účastníci",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Kliknutím na Další informace navštívíte naši stránku podpory",
  "Further information": "Další informace",
  
  // LocationSetting
  "Location changed": "Umístění změněno",
  "Location change failed": "Změna umístění se nezdařila",
  "Please select at least one location": "Vyberte prosím alespoň jedno umístění",
  "Resource types": "Typy zdrojů",
  "Location": "Umístění",
  "Where": "Kde",
  
  // ModalShowAttendees
  "Total": "Celkem",
  "Available": "Dostupný",
  "Busy": "Zaneprázdněn",
  "External": "Externí",
  "Internal": "Interní",
  
  // ResourceSearch
  "Search by resource name": "Hledat podle názvu zdroje",
  "Category": "Kategorie",
  "Filter by Location": "Filtrovat podle umístění",
  "Filter by Category": "Filtrovat podle kategorie",
  "Capacity": "Kapacita",
  "Filter by Capacity": "Filtrovat podle kapacity",
  "All": "Vše",
  "Filter by availability": "Filtrovat podle dostupnosti",
  "Sort By": "Seřadit podle",
  "Loading...": "Načítání...",
  "No Resources available": "Nejsou k dispozici žádné zdroje",
  
  // SelectedResources
  "Meeting Type": "Typ schůzky",
  "Meeting Label": "Štítek schůzky",
  
  // Alert (accessibility text)
  "Check icon": "Ikona zaškrtnutí",
  "Close": "Zavřít",
  
  // AppConstants - searchTab
  "Resource": "Zdroj",
  "Person": "Osoba",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Kde se obvykle konají vaše schůzky?",
  "To improve our recommendations for you we would like you to enter your normal location": "Pro zlepšení našich doporučení byste měli zadat své běžné umístění",
  "What do you use most?": "Co používáte nejčastěji?",
  "To enable quicker and better search please chose you prefered resource type": "Pro rychlejší a lepší vyhledávání zvolte svůj preferovaný typ zdroje",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Kliknutím na zdroj jej vyberete",
  "Selected Resources": "Vybrané zdroje",
  "Setting": "Nastavení",
  "Search": "Vyhledávání",
  "Find Colleague": "Najít kolegu",
  "Quick button setting": "Nastavení rychlého tlačítka",
  "Favorite": "Oblíbené",
  "Most Used": "Nejpoužívanější",
  "Colleagues": "Kolegové",
  "Resources": "Zdroje",
  
  // AppConstants - tooltipText
  "Back": "Zpět",
  "Floor Plan": "Půdorys",
  "Expand": "Rozbalit",
  "Selected resources": "Vybrané zdroje",
  "View details": "Zobrazit podrobnosti",
  "Remove from My Favorites": "Odebrat z oblíbených",
  "Add to My Favorites": "Přidat do oblíbených",
  "Remove": "Odebrat",
  "Favorite - Most Used": "Oblíbené - Nejpoužívanější",
  "Conflict": "Konflikt",
  "Approved": "Schváleno",
  "Recommendeded for you": "Doporučeno pro vás",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Pouze hlavní organizátor",
  "Only assistant organizer": "Pouze asistent organizátora",
  "Primary AND assistant organizer": "Hlavní A asistent organizátora",
  
  // FindColleague
  "Enter colleague name": "Zadejte jméno kolegy",
  "Recent work items": "Nedávné pracovní položky",
  "No data available": "Nejsou k dispozici žádná data",
  "Floorplan": "Půdorys",
  "List nearby resources": "Seznam zdrojů v okolí",
  "Find resource nearby": "Najít zdroj v okolí",
  
  // Start page
  "Next": "Další",
  "Failed to update default locations": "Nepodařilo se aktualizovat výchozí umístění",
  "Resource Type": "Typ zdroje",
  
  // QuickSetting
  "Quick buttons updated successfully": "Rychlá tlačítka úspěšně aktualizována",
  "Quick buttons updated failed": "Aktualizace rychlých tlačítek se nezdařila",
  "Add more": "Přidat další",
  "Apply": "Použít",
  "Delete": "Smazat",
  "Name": "Název",
  "Enter name": "Zadejte název",
  "Tooltip": "Nápověda",
  "Enter tooltip": "Zadejte nápovědu",
  "Type": "Typ",
  "Select type": "Vyberte typ",
  "Locations": "Umístění",
  "Select colleagues": "Vyberte kolegy",
  "Select resources": "Vyberte zdroje",
  
  // DefaultResourceSetting
  "Resource type changed": "Typ zdroje změněn",
  "Resource type change failed": "Změna typu zdroje se nezdařila",
  "Default Resource Type": "Výchozí typ zdroje",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Úspěšně použito",
  "Apply Failed": "Použití se nezdařilo",
  "Assistant Organizer": "Asistent organizátora",
  "Enter a part of the name to search for": "Zadejte část jména pro vyhledávání",
  "Mail Flow": "Tok e-mailů",
  "Select Mail Flow": "Vyberte tok e-mailů",
  
  // TileConfigurationSetting
  "Update settings successfully": "Nastavení úspěšně aktualizováno",
  "Update settings failed": "Aktualizace nastavení se nezdařila",
  "Timeline": "Časová osa",
  
  // SelectCategoryForm
  "And": "A",
  "Or": "Nebo",
  
  // Other
  "Resource Calendar": "Kalendář zdrojů",
  
  // SettingLabels
  "Default Location": "Výchozí umístění",
  "Quick button": "Rychlé tlačítko",
  "Category icons": "Ikony kategorií",
  "Recommendation screen": "Doporučená obrazovka",
  "Capacity filter": "Filtr kapacity",
  "AI Assistant": "AI Asistent",
  "Tile configuration": "Konfigurace dlaždic",
  "Help": "Nápověda",
  "Default Categories": "Výchozí kategorie",
  
  // MeetingType
  "Your must select a Meeting label": "Musíte vybrat štítek schůzky",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Vybraný zdroj: 'AOD_Copanhagen' Konfliktní výskyty",
  "Alternative Resource": "Alternativní zdroj",
  "OK": "OK",
  "Cancel": "Zrušit",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Váš vybraný zdroj 'AOD_Copenhagen' byl odstraněn",
  "You can't book this resource as your request exceeds the available capacity.": "Nemůžete rezervovat tento zdroj, protože váš požadavek přesahuje dostupnou kapacitu.",
  
  // ChangeTime
  "Time changed successfully": "Čas úspěšně změněn",
  "Current Time": "Aktuální čas",
  "Suggested Times": "Navrhované časy",
  "Change Time": "Změnit čas",
  "people are free": "lidé jsou volní",
};

